import { useState, useEffect } from 'react';
import { isLogoutInProgress } from './utils';

export const useLogoutState = () => {
  const [logoutInProgress, setLogoutInProgressState] = useState(false);

  useEffect(() => {
    // Check initial state
    setLogoutInProgressState(isLogoutInProgress());

    // Set up an interval to check for logout state changes
    const interval = setInterval(() => {
      const currentState = isLogoutInProgress();
      setLogoutInProgressState(currentState);
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return logoutInProgress;
};
